import { useRef } from 'react';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

const VolunteerSearcher = (props) => {
  const { onChangeSearchValue } = props;
  const searchRef = useRef();

  return (
    <>
      <Alert severity="info">
        Обратите внимание, поиск производится по всем полям анкет волонтёров, за
        исключением анкет, находящихся за пределами активной вкладки ниже. Если
        Вы хотите искать по всем членам ЦЗР, рекомендуем сначала переключиться
        на вкладку "Все" ниже. Если результат поиска Вас не устроил, то нажмите
        на кнопку "Найти", оставив поисковое поле пустым, чтобы вернуть исходный
        результат.
      </Alert>

      <Box maxWidth="lg" sx={{ mt: 1 }}>
        <TextField
          ref={searchRef}
          sx={{ width: '89%', mr: 1, mb: 1 }}
          size="small"
          label="Поле для ввода..."
          variant="outlined"
        />

        <Button
          variant="outlined"
          size="medium"
          onClick={() =>
            onChangeSearchValue(
              searchRef.current.childNodes[1].firstChild.value
            )
          }
        >
          Найти
        </Button>
      </Box>
    </>
  );
};

export default VolunteerSearcher;
